/* @ngInject */
function ColumnTagController ($scope, $translate, $timeout, BoardColumnsService, ToastService, UdsModalService, $rootScope) {
  const getBoardStatusAlertDialogController = () => import('../../dialogs/board-status-alert/board-status-alert-dialog.controller')

  $scope.sortOptions = ['manual', 'priority', 'deliveryDate', 'finishDate', 'createdAt']
  $scope.statusOptions = ['INBOX', 'PROGRESS', 'REVIEW', 'WAITING_ADM_ADJUST', 'DONE']

  const api = {
    getBoardStatusAlertDialogController,
    _successUpdateStatus,
    _errorUpdateStatus
  }
  this.getApi = () => api

  activate()

  function activate () {
    $timeout(() => {
      $('.add-status-dropdown').dropdown()
    })
  }

  $scope.getFontColor = (status) => {
    const colors = {
      INBOX: 'feedbackColorYellowDark',
      PROGRESS: 'feedbackColorBlueDark',
      REVIEW: 'feedbackColorPurpleDark',
      WAITING_ADM_ADJUST: 'feedbackColorOrangeDark',
      DONE: 'feedbackColorGreenDark'
    }

    return colors[status]
  }

  $scope.getStatusLabel = (status) => {
    const labels = {
      INBOX: 'inboxStatus',
      PROGRESS: 'inProgress',
      REVIEW: 'underReview',
      WAITING_ADM_ADJUST: 'adjustments',
      DONE: 'done'
    }

    return $translate.instant(labels[status])
  }

  $scope.selectStatus = (status) => {
    $scope.column.defaultStatus = status
    BoardColumnsService.updateBoardColumn($scope.column.id, $scope.column)
      .then(api._successUpdateStatus)
      .catch(api._errorUpdateStatus)
  }

  $scope.openAlertDialog = () => {
    getBoardStatusAlertDialogController().then(({ BoardStatusAlertDialogController }) => {
      const boardStatusAlertDialogDirective = UdsModalService.createModal({
        controller: BoardStatusAlertDialogController,
        modalName: 'boardStatusAlertDialogDirective',
        data: {
          boardId: $scope.boardId,
          hideStatusAlert: $scope.hideStatusAlert,
          hideCheckbox: true
        }
      })

      boardStatusAlertDialogDirective.open()
    })
  }

  function _successUpdateStatus () {
    ToastService.showSuccessToast($translate.instant('successUpdateStatus'))
  }

  function _errorUpdateStatus () {
    ToastService.defaultErrorToast()
  }
}

export { ColumnTagController }
